import { ACCESS_SERVICES_MAP, APP_SERVICE, PAYMENT_METHOD, PAYMENT_METHOD_CONFIG } from "../constants"

export const getPaymentMethodsSupport = restaurant => {
    const paymentFromConfig = APP_SERVICE === ACCESS_SERVICES_MAP.WEB
        ? restaurant.settings?.paymentDeliver || []
        : restaurant.settings?.paymentQrlive || []
    const paymentMethods = paymentFromConfig.map(pmt => pmt.code)
    const paymentMethodsMapped = []

    paymentMethods.includes(PAYMENT_METHOD_CONFIG.OFFLINE_CASH) &&
    paymentMethodsMapped.push(PAYMENT_METHOD.CASH)

    paymentMethods.includes(PAYMENT_METHOD_CONFIG.OFFLINE_CARD) &&
    paymentMethodsMapped.push(PAYMENT_METHOD.CASH_CARD)

    paymentMethods.includes(PAYMENT_METHOD_CONFIG.ONLINE_PAYPAL) &&
    restaurant.paypalClientId &&
    paymentMethodsMapped.push(PAYMENT_METHOD.PAYPAL)

    return paymentMethodsMapped
}

export const getInitMethod = methods => {
    if (methods.includes(PAYMENT_METHOD.CASH)) {
        return PAYMENT_METHOD.CASH
    }

    return methods[0] || PAYMENT_METHOD.CASH
}